import React from "react";

const PtoModal = ({ employee, onClose }) => {
  if (!employee) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-[500px]">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-3 py-2">
          <h2 className="text-[18px] font-semibold text-[#101828]">
            PTO Requests for {employee.name}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-xl"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-3">
          <div className="border border-[#E5E7EB] flex flex-col justify-start items-start rounded-xl p-3 bg-white">
            {/* Vacation + Status */}
            <div className="flex justify-center items-center gap-2 mb-3">
              <div className="font-normal text-[16px] font-inter text-[#101828]">
                Vacation
              </div>
              <div className="bg-[#FEF9C2] px-[6px] py-[2px] rounded-full">
                <div className="text-[#A65F00] text-[12px] font-inter font-medium">
                  Pending
                </div>
              </div>
            </div>

            {/* From / To */}
            <div className="grid grid-cols-2 gap-y-1 mb-3">
              <div className="flex justify-center items-center gap-2">
                <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                  From:
                </div>
                <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                  Dec 20, 2025
                </div>
              </div>
              <div className="flex justify-center items-center gap-2">
                <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                  To:
                </div>
                <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                  Dec 24, 2025
                </div>
              </div>
            </div>

            {/* Duration */}
            <div className="flex justify-center items-center gap-2">
              <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                Duration:
              </div>
              <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                5 days (40 hours)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PtoModal;
